import APIConstant from 'constants/ApiConstant';
import { makeAutoObservable, runInAction } from 'mobx';
import { deleteRequest, getRequest, postRequest } from 'utils/apiUtils';
import { getValidDataFromResponse, sendNotification } from 'utils/utilities';

class CompetencyStore {
    competencyList = [];
    competencyDetails = [];
    isLoading = false;
    isSubmitting = false;
    isDeleting = false;
    deleteRowId = null;

    constructor() {
        makeAutoObservable(this);
    }

    getCompetencyList = async (params = {}) => {
        try {
            this.setIsLoading(true);

            let url = APIConstant.GET_COMPETENCY_LIST;
            const queryParams = [];
            if (params.state_id) queryParams.push(`state_id=${params.state_id}`);
            if (queryParams.length > 0) url += `?${queryParams.join('&')}`;

            const { response } = await getRequest({ url });
            const { result, error } = getValidDataFromResponse({ response, isRequired: false });

            if (!error) {
                runInAction(() => {
                    this.competencyList = result || [];
                });
            }

            this.setIsLoading(false);
        } catch (error) {
            console.log('error :>> ', error);
            this.setIsLoading(false);
        }
    };

    getCompetencyDetailsById = async (competencyId) => {
        try {
            const { response } = await getRequest({ url: `${APIConstant.GET_COMPETENCY_DETAILS_BY_ID}/${competencyId}` });
            const { result, error } = getValidDataFromResponse({ response, isRequired: false });

            if (!error) {
                runInAction(() => {
                    this.competencyDetails = result || [];
                });
            }
        } catch (error) {
            console.log('error :>> ', error);
        }
    };

    createCompetency = async (body) => {
        try {
            this.setIsSubmitting(true);
            const { response } = await postRequest({ url: APIConstant.CREATE_COMPETENCY, payload: body });
            const { result, error } = getValidDataFromResponse({ response });

            if (!error) {
                sendNotification({ type: 'success', message: 'Competency created successfully' });
                this.setIsSubmitting(false);
                return result;
            } else {
                throw new Error('Something went wrong');
            }
        } catch (error) {
            sendNotification({ type: 'error', message: 'Something went wrong' });
            this.setIsSubmitting(false);
            throw error;
        }
    };

    deleteCompetency = async (toolboxMeetingId, row) => {
        try {
            runInAction(() => {
                this.isDeleting = true;
                this.deleteRowId = row;
            });

            const { response } = await deleteRequest({ url: `${APIConstant.DELETE_COMPETENCY}/${toolboxMeetingId}` });
            const { error } = getValidDataFromResponse({ response });

            if (!error) {
                sendNotification({ type: 'success', message: 'Competency deleted successfully' });
                runInAction(() => {
                    this.isDeleting = false;
                    this.deleteRowId = null;
                });
                return true;
            } else {
                throw new Error('Something went wrong');
            }
        } catch (error) {
            sendNotification({ type: 'error', message: 'Something went wrong' });
            runInAction(() => {
                this.isDeleting = false;
                this.deleteRowId = null;
            });
            throw error;
        }
    };

    setIsLoading = (value = false) => {
        runInAction(() => {
            this.isLoading = value;
        });
    };

    setCompetencyList = (data = []) => {
        runInAction(() => {
            this.competencyList = data;
        });
    };

    setIsSubmitting = (value = false) => {
        runInAction(() => {
            this.isSubmitting = value;
        });
    };
}

export default CompetencyStore;
